<template>
  <nav class="navbar navbar-light bg-light fixed-top toolbar menu-color" :class="{'branding-wrapper' :
  isConf2GoActive}"

  ><!--:style="{top: isIos ? '40px' : '0px'}"-->
    <div class="container-fluid px-0" style="height: 100% !important">
      <div :style="{'margin-top': isIos ? ' 15px !important;' : '0px'}" style="z-index: 20">

        <a class="px-0 mx-0" v-if="historyCount > 0" @click="goBack()">
          <ion-icon class="mobile-activated menu-conference"
                    style="margin-bottom: 15px !important; font-size: 2rem; vertical-align:bottom;"
                    :name="'chevron-back-outline'"></ion-icon>
          <ion-icon class="mobile-deactivated menu-conference"
                    style="margin-bottom: 15px !important; font-size: 2rem; vertical-align:bottom;"
                    :name="'chevron-back-outline'"></ion-icon>
        </a>

        <button class="navbar-toggler px-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar">

          <ion-icon class=" menu-conference" style="font-size: 2rem; vertical-align:bottom;"
                    :name="'menu-outline'"></ion-icon>
          <span v-if="unreadTotal > 0"
                class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
                style="top:20px;font-size:0.6rem; background: #fff !important;color:#69A653">
                {{ unreadTotal }}
              </span>
        </button>
        <button class="btn btn-light update-button mobile-deactivated"
                style="background:transparent; margin-top:-14px; color:#000"
                type="button"
                @click="update">
          <div title="Check for updates">
            <ion-icon class="menu-conference" style="pointer-events:none;margin-right: 4px; font-size: 26px; vertical-align:bottom;"
                      aria-label="Check for updates" title="Check for updates"
                      :name="'sync-outline'"
                      :style="{'animation': (syncActive ? '0.75s linear infinite spinner-border' : 'none')}"></ion-icon>
          </div>

        </button>
        <router-link class="btn btn-light navbar-brand menu-conference mobile-activated px-1"
                     style="height: 100% !important; padding-top: 0px; padding-bottom: 0px; background:transparent; border:none;"
                     to="/app/dashboard">
          <ion-icon class="menu-conference"
              style="margin-bottom: 18px !important; font-size: 26px; vertical-align:bottom;"
              :name="'home-outline'"></ion-icon>

        </router-link>
      <router-link class="navbar-brand menu-conference mobile-deactivated px-0"
                   style="height: 100% !important; padding-top: 0px; padding-bottom: 10px; z-index: 20"
                   to="/app/dashboard">
        <ion-icon class="menu-conference" style="margin-bottom: 8px; font-size: 26px; vertical-align:bottom;"
                  :name="'home-outline'"></ion-icon>
      </router-link>

               <button v-if="!user || !user.id" @click="login()" 
               style="position:absolute; top:8px; right:95px; align-items: center; gap: 4px; 
               background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.4);
               border-radius: 20px; padding: 4px 12px; backdrop-filter: blur(4px);" 
               class="navbar-toggler mobile-deactivated"
               type="button" >
         <ion-icon class="menu-conference" style="padding-bottom: 0px; font-size: 20px; vertical-align:middle;"
                   :name="'person-circle-outline'"></ion-icon>
         <span class="menu-conference" style="font-size: 13px; font-weight: 600; letter-spacing: 0.3px;">{{ wordings[currentLanguage].LOGIN }}</span>
            </button>
               <div v-if="user && user.id" class="mobile-deactivated" style="position:absolute; top:8px; right:95px;">
               <button @click="userMenuOpen = !userMenuOpen" 
               style="align-items: center; gap: 4px; 
               background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.4);
               border-radius: 20px; padding: 4px 12px; backdrop-filter: blur(4px);" 
               class="navbar-toggler"
               type="button" >
         <ion-icon class="menu-conference" style="padding-bottom: 0px; font-size: 20px; vertical-align:middle;"
                   :name="'person-circle-outline'"></ion-icon>
         <span class="menu-conference" style="font-size: 13px; font-weight: 600; letter-spacing: 0.3px;">{{ user.firstName }} {{ user.lastName }}</span>
            </button>
            <div v-if="userMenuOpen" class="user-dropdown" 
                 style="position: absolute; top: 100%; right: 0; margin-top: 4px; background: #fff; 
                 border-radius: 10px; box-shadow: 0 4px 16px rgba(0,0,0,0.15); overflow: hidden; z-index: 9999; min-width: 180px;">
              <a @click="userMenuOpen = false; $router.push('/app/favorites')" 
                 style="display: flex; align-items: center; gap: 8px; padding: 10px 16px; color: #333; text-decoration: none; cursor: pointer; font-size: 14px; font-weight: 500; border-bottom: 1px solid #eee;">
                <ion-icon :name="'heart-outline'" style="font-size: 18px;"></ion-icon>
                Favoriten
              </a>
              <a @click="userMenuOpen = false; goToProfile()" 
                 style="display: flex; align-items: center; gap: 8px; padding: 10px 16px; color: #333; text-decoration: none; cursor: pointer; font-size: 14px; font-weight: 500;">
                <ion-icon :name="'person-circle-outline'" style="font-size: 18px;"></ion-icon>
                Profil
              </a>
            </div>
            </div>

               <button v-if="chat_enabled" @click="goToChat()"  style="position:absolute; top:12px; right:55px" class="navbar-toggler"
               type="button" >
         <ion-icon class="menu-conference" style="  padding-bottom: 0px; font-size: 25px; vertical-align:bottom;"
                   :name="'chatbubble-outline'"></ion-icon>    
            </button>

               <button @click="goToNews()"  style="position:absolute; top:12px; right:15px" class="navbar-toggler"
               type="button" >
         <ion-icon class="menu-conference" style="  padding-bottom: 0px; font-size: 25px; vertical-align:bottom;"
                   :name="'newspaper-outline'"></ion-icon>    
                     <span v-if="unreadNews > 0"
               class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
               style="font-size: 0.65rem; padding: 0.25em 0.5em;">
           {{ unreadNews }}
         </span>
            </button>
         <ul class="navbar-nav justify-content-center flex-grow-1 pe-3 mobile-deactivated "
                style="margin-left: 20px; vertical-align:top"
                v-for="link in menulinksTop" :key="link.id">
              <top-menu-item :link="link"></top-menu-item>
            </ul>
      </div>
      
      <router-link class="navbar-brand menu-conference mobile-activated menu-top-title px-0"
                   style="" to="/app/dashboard"><b>
      </b></router-link>


      <div
           style="height: 100% !important; padding-top: 0px; padding-bottom: 0px;top:5px; right: 0px; z-index: 20"
           class="navbar-brand menu-conference mobile-deactivated px-1 position-absolute end-0"
           type="button">
        <ion-icon class="mobile-deactivated"
                  style="margin-bottom: 4px !important;color:#fff !important; margin-left:5px; font-size: 26px; vertical-align:bottom; "
                  v-if="!onLine"
                  :name="'cloud-offline-outline'"></ion-icon>

      </div>

      <div class="navbar-brand menu-conference mobile-deactivated" v-if="!isConf2GoActive && multiConf"
           style="height: 100% !important; padding-top: 0px; padding-bottom: 0px;" @click="backToSociety()">
        <ion-icon style="margin-right: 4px; font-size: 26px; vertical-align:bottom" :name="'copy-outline'"></ion-icon>

      </div>

      <div class="navbar-brand menu-conference  menu-top-title">
        
        <div class="menu-top-text menu-conference" v-if="!hasMenuLogo">
          <b style="font-size:16px; letter-spacing: -1px;  font-weight: 900;" :style="{'color':'#fff'}"> dcuemediaS 2026</b>
        </div>
        
        <div v-else class="menu-top-text menu-conference"  >
             <img  style=" height:30px !important" src="@/assets/menulogo.png"/>
        </div>
      </div>
      <div  style="margin-bottom: 10px" class="mobile-activated menu-conference"
           type="button">
        <ion-icon class="mobile-activated"
                  style="margin-bottom: 4px !important;color:#fff !important; margin-right:5px; font-size: 26px; vertical-align:bottom; "
                  v-if="!onLine"
                  :name="'cloud-offline-outline'"></ion-icon>

               <button v-if="chat_enabled" @click="goToChat()"  style="position:absolute; top:12px; right:55px" class="navbar-toggler"
               type="button" >
         <ion-icon style="  padding-bottom: 0px; font-size: 25px; vertical-align:bottom; color:white "
                   :name="'chatbubble-outline'"></ion-icon>    
            </button>

                <button @click="goToNews()"  style="position:absolute; top:12px; right:15px" class="navbar-toggler"
               type="button" >
         <ion-icon style="  padding-bottom: 0px; font-size: 25px; vertical-align:bottom; color:white "
                   :name="'newspaper-outline'"></ion-icon>
         <span v-if="unreadNews > 0"
               class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
               style="font-size: 0.65rem; padding: 0.25em 0.5em;">
           {{ unreadNews }}
         </span>
            </button>


      </div>

      	
    

      <div class="offcanvas offcanvas-start canvas-mobile-offset" tabindex="-1" id="offcanvasNavbar"
           aria-labelledby="offcanvasNavbarLabel" :style="{'top': isIos ? '47px' : '0px'}">
        <!-- :style="{top: isIos ? '47px' : '0px'}"-->
        <button type="button" class="btn-close text-reset btn-close-white " style="z-index: 9000;"
                data-bs-dismiss="offcanvas"
                aria-label="Close"></button>
        <div class="canvas-profile"
             :style="{
               'background-image': menuheader ? getMenuBackgroundImage : '',
               'background-size': 'cover',
               'background-position': 'center center',
               'background-repeat': 'no-repeat'
             }"
             :class="{'canvas-profile-background': !menuheader}">

        </div>

        <div style="position:relative;">
          <button type="button" class="btn btn-primary  profile-button-mobile profile-button-login login-color"
                  style="display: inline-block"
                 
                  v-if="!user || !user.id" @click="login()"> {{ wordings[currentLanguage].LOGIN }}
          </button>
          <template v-if="user">
            <button type="button" class="btn btn-primary  profile-button-mobile login-color" v-if="user.id"
                    data-bs-dismiss="offcanvas" style="display: inline-block"
                    @click="goToProfile()"
                   >
              {{
                user.firstName
              }} {{ user.lastName }} 
            </button>
          </template>
          <template v-if="user">
            <button type="button" class="btn btn-primary  logout-button-mobile logout-color" v-if="user.id"
                    @click="logOutAlert()" data-bs-dismiss="offcanvas" style="display: inline-block"
                    :style="{'background' : primaryColor + '!important'}">
              <ion-icon
                  style="margin-left:5px; font-size: 24px;"
                  :name="'log-out-outline'"></ion-icon>
            </button>
          </template>
        </div>


   


        <div class="offcanvas-body custom-offcanvas-body" style="margin-bottom: 40px">



          <div>
            <span>
                 <button class="btn btn-light mobile-update-button  " type="button" @click="update"
                         :style="{'background' : primaryColor + '!important'}" data-bs-dismiss="offcanvas">
            <small style="position: absolute; bottom:6px; left:10px">{{ versionString }}</small>

            {{ wordings[currentLanguage].DATA_UPDATE }}

            <ion-icon style="margin-right: 4px; font-size: 26px; vertical-align:bottom"
                      :name="'sync-outline'"
                      :style="{'animation': (syncActive ? '0.75s linear infinite spinner-border' : 'none')}"></ion-icon>
          </button>
                 </span>
            <span v-if="!isConf2GoActive && multiConf">
                 <button type="button" class="btn btn-primary mobile-activated change-button-mobile" v-if="user.id"
                         @click="backToSociety()" data-bs-dismiss="offcanvas">  <ion-icon
                     :name="'copy-outline'"></ion-icon> </button>
                </span>
          </div>


          <div class="d-flex mb-2">
            <input class="form-control me-2 " type="search"
                   :placeholder="wordings[currentLanguage].SEARCH" aria-label="Search"
                   v-model="searchterm" @keyup.enter="search()">
            <ion-icon class=" mobile-search-icon"
                      :name="'search-circle-outline'" @click.prevent="search()" data-bs-dismiss="offcanvas"
                      data-bs-target="offcanvasNavbar"></ion-icon>
          </div>

          <!--template v-if="!isConf2GoActive && updateFinished">
            <ul class="navbar-nav justify-content-center flex-grow-1 pe-3 mobile-deactivated "
                style="margin-left: 20px;"
                v-for="link in menulinksTop" :key="link.id">
              <top-menu-item :link="link"></top-menu-item>
            </ul>
          </template-->

          <ul class="navbar-nav justify-content-center flex-grow-1 " style=" min-height:40px;width: 90%"
              v-for="link in menulinks" :key="link.id">
            <menu-item :link="link"></menu-item>
          </ul>


          <hr style="width: 100%" class="mobile-activated">
          <ul v-if="user" class="navbar-nav justify-content-end flex-grow-1 pe-3 mobile-activated"
              style="margin-left: 20px; width: 100%">
            <li v-if="user.id" class="nav-item toolbar-link">

            </li>
          </ul>



        </div>
      </div>
    </div>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbarNews"
         aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-header ">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        <span class="offcanvas-title">News</span>
      </div>
    </div>
  </nav>
  <Toast></Toast>
  <Splash></Splash>
  <ConsentDisclaimer v-if="loginRequired"></ConsentDisclaimer>
  <Help></Help>
  <!--ion-router-outlet id="main-content" animated="false">
  </ion-router-outlet-->
  <router-view id="main-content"></router-view>
  <!--/ion-split-pane-->

  <ChangeBrowser></ChangeBrowser>
</template>
<script>
import {
  alertController,
  //IonRouterOutlet,
  toastController,  
} from "@ionic/vue";
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import {addIcons} from "ionicons";
import {
  personCircleOutline,
  chatbubbleOutline,
  radioOutline,
  syncOutline,
  logOutOutline,
  logInOutline,
  searchCircleOutline,
  homeOutline,
  chevronBackOutline,
  cloudOfflineOutline,
  menuOutline,
  copyOutline,
  newspaperOutline,
   heartOutline
} from "ionicons/icons";
import NewsList from "@/views/News/NewsList";
import Toast from "@/components/ToastContainer";
import Splash from "@/components/Splash";
import Help from "@/components/Help";
import ConsentDisclaimer from "@/components/ConsentDisclaimer.vue";


import ChangeBrowser from "@/components/ChangeBrowser";

addIcons({
  "sync-outline": syncOutline,
  "person-circle-outline": personCircleOutline,
  "log-out-outline": logOutOutline,
  "log-in-outline": logInOutline,
  "chatbubble-outline": chatbubbleOutline,
  "search-circle-outline": searchCircleOutline,
  "home-outline": homeOutline,
  "chevron-back-outline": chevronBackOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  "menu-outline": menuOutline,
  'copy-outline': copyOutline,
  "radio-outline": radioOutline,
        "newspaper-outline":newspaperOutline,
              "heart-outline":heartOutline,


});
const config = require('@/config')
import {isPlatform} from '@ionic/vue';
import router from '@/router';
import {store} from "@/store";
import MenuItem from './MenuItem.vue';
import TopMenuItem from './TopMenuItem.vue';
import moment from 'moment';

export default {
  components: {
    //IonRouterOutlet,
    NewsList,
    Toast,
    Splash,
    ChangeBrowser,
    MenuItem,
    TopMenuItem,
    Help,
    ConsentDisclaimer
  },
  data() {
    return {
      menulinks: [],
      menulinksTop: [],
      title: config.full_name,
      isConsultant: false,
      userConsultant: null,
      isDesktop: null,
      isIos: null,
      video_chat_enabled: false,
      chat_enabled: config.chat_enabled,
      confDate: config.conf_date,
      openSubBar: false,
      sublinks: null,
      time: null,
      appointmentsRole: null,
      searchterm: '',
      hideSearchBar: false,
      historyCount: 0,
      loginAlertOpen: false,
      onLine: navigator.onLine,
      showBackOnline: false,
      multiConf: config.is_multi_conf_app,
      //  available_languages: ['en','de'],
      flagMapper: {
        'en': 'gb'
      },
      versionString: isPlatform('ios') ? config.versionIOS : config.versionAndroid,
      consent_disclaimer: '',
      loginRequired: config.loginRequired,
      hasMenuLogo: config.has_menulogo,
      userMenuOpen: false

    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user']),
    ...mapState('splashscreen', ['showSplashscreen']),
    ...mapState('personalDB', ['unreadNews']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapGetters('currentConference', ['isSociety', 'isConf2GoActive']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'primaryColor', 'menuheader']),
    ...mapState('messages', ['unreadSystemMessages']),

    getMenuBackgroundImage() {
      return this.menuheader ? 'url("' + this.menuheader + '")' : 'url("@/assets/canvas-bg.png")';
    },


  },
  methods: {
    ...mapActions("settings", [
      "getSetting", 'getConfig'
    ]),
    ...mapActions('menulinks', ['getAllLinks', 'getParents']),
    ...mapActions('sync', ['start']),
    ...mapActions("exhibitors", ["getAllExhibitors"]),
    ...mapActions('menulinks', ['getAllLinks', 'getParents', 'getTopItems', 'getChildren']),
    ...mapActions('auth', ['GET_USERDATA']),
    ...mapMutations('splashscreen', ['setShowSplash']),
    ...mapActions("personalDB", ["connectPersonalDB", 'getItem', 'getItems', 'prepareFavoriteList', 'setTime', 'getUnreadNews']),
    ...mapMutations('personalDB', ['setUnreadNews']),
    ...mapActions('chat', ['getUnreadMessagesTotalCount']),
    ...mapActions('currentConference', ['backToSociety']),
    ...mapMutations('currentConference', ['setPrimaryColor', 'setMenuHeader', 'setAltFont', 'setIcon']),
    ...mapActions('wordings', ['changeLanguage']),


    async changeSettings() {
      let pc = await this.getConfig('primary_color')
      let af = await this.getConfig('alt_font')
      let i = await this.getConfig('icon')
      let h = await this.getConfig('head')
      let langs = await this.getConfig('available_languages')
      this.available_languages = langs ? langs.split(',') : ['en', 'de']
      this.setPrimaryColor(pc)
      this.setAltFont(af)
      this.setIcon(i)
      this.setMenuHeader(h)
    },

    switchLanguage(lang) {
      console.log('SWITCH LANG', lang);
      this.changeLanguage(lang)
      // Update moment locale when language changes
      if (typeof moment !== 'undefined') {
        moment.locale(lang);
      }
    },
    getFlag(lang) {
      return this.flagMapper[lang] || lang;
    },


    goBack() {
      let newCount = window.history.length - this.historyCount
      //this.$router.go(-1)
      window.history.back();
      /*if(this.historyCount > 0){
        this.$router.go(-1)
      }else{
        this.$router.push('/');
      }*/
    },

    async showSyncToast() {
      const toast = await toastController
          .create({
        message: this.wordings[this.currentLanguage].UP_TO_DATE,
            duration: 2000,
            position: 'bottom',
            animated: 'true',
            color: 'primary',
            cssClass: 'toast-bg'
          })
      return toast.present();
    },

    async update() {
      let res = await this.start();
      if (res) {
        this.showSyncToast();
      }
    },

    goToNews() {
            this.$router.push('/app/posts/');
    },

    goToChat() {
      if (this.user && this.user.id) {
        this.$router.push('/app/chat/');
      } else {
        this.chatAlert()
      }
    },


    updateOnlineStatus(e) {
      const {
        type
      } = e;
      this.onLine = type === 'online';
    },

    async search() {

      var myOffcanvas = document.getElementById('offcanvasNavbar');
      if (myOffcanvas.classList.contains("show")) {
        myOffcanvas.classList.remove("show");
      }
      document.querySelectorAll('.offcanvas-backdrop').forEach(function (a) {
        a.remove()
      })
      this.$router.push('/app/search/' + this.searchterm);
      this.searchterm = ''
    },

    openMenu() {
      console.log('openMenu called');
      const offcanvasElement = document.getElementById('offcanvasNavbar');
      console.log('Found offcanvas element:', offcanvasElement);
      console.log('Bootstrap available:', typeof bootstrap !== 'undefined');
      
      if (offcanvasElement && !offcanvasElement.classList.contains('show')) {
        console.log('Attempting to open menu...');
        
        // Try clicking the hamburger button instead of programmatic approach
        const menuButton = document.querySelector('[data-bs-toggle="offcanvas"][data-bs-target="#offcanvasNavbar"]');
        console.log('Menu button found:', menuButton);
        
        if (menuButton) {
          console.log('Clicking menu button programmatically');
          
          // Set proper z-index immediately
          offcanvasElement.style.zIndex = '1045';
          
          // Click the button
          menuButton.click();
          
          // Wait a moment for Bootstrap to add the backdrop, then fix its z-index
          setTimeout(() => {
            const backdrop = document.querySelector('.offcanvas-backdrop');
            if (backdrop) {
              backdrop.style.zIndex = '1040';
              console.log('Fixed backdrop z-index');
            }
          }, 50);
        } else {
          console.log('Menu button not found, trying direct approach');
          // Direct approach - simulate what Bootstrap does
          offcanvasElement.classList.add('show');
          offcanvasElement.style.visibility = 'visible';
          offcanvasElement.style.zIndex = '1045';
          
          // Add backdrop
          const backdrop = document.createElement('div');
          backdrop.className = 'offcanvas-backdrop fade show';
          backdrop.style.zIndex = '1040';
          backdrop.addEventListener('click', () => {
            offcanvasElement.classList.remove('show');
            backdrop.remove();
            offcanvasElement.style.zIndex = '';
          });
          document.body.appendChild(backdrop);
          document.body.classList.add('offcanvas-open');
        }
      } else {
        console.log('Element not found or already showing');
      }
    },


    async prepareLinks() {
      this.menulinks = (await this.getParents()).sort((a, b) => a.order - b.order);
    },
    async prepareLinksTop() {
      this.menulinksTop = (await this.getTopItems()).sort((a, b) => a.order - b.order);
    },

    goToMessages() {
      this.$router.push('/app/messages/');
    },

    async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: this.wordings[this.currentLanguage].LOGIN_REQUIRED,
            message: this.wordings[this.currentLanguage].LOG_IN_QUESTION,
            buttons: [
              {
                text: this.wordings[this.currentLanguage].NO_ANSWER,
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: this.wordings[this.currentLanguage].YES_ANSWER,
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },

   async loginByToken(tokenSent) {
      //check for token in path
      let token = tokenSent
      if (token) {

        localStorage.setItem("x-api-key", token);

        let userRequest = await store.dispatch("auth/GET_USERDATA");
        //this.user = userRequest.data;

        let tmpUser = userRequest.data;

        if (tmpUser) {
          console.log('USER', tmpUser)

            if (!tmpUser.extra) {
              tmpUser.extra = {};
            }

       
          await store.commit("auth/SET_USER", tmpUser);
          localStorage.setItem('user', JSON.stringify(tmpUser));
        }
        //splice the path
        window.history.pushState(
            {},
            document.title,
            '/'
        );
        router.push({name: 'Dashboard'});

      } else {
        router.next();
      }
      router.next();

    },

    async login() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });

        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
          redirect(link.toString());
        }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });


      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }
    },

    goToProfile() {
      this.$router.push('/app/userinfo');
    },


    async logOutAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Log Out',
            message: this.wordings[this.currentLanguage].LOGOUT,
            buttons: [
              {
                text: this.wordings[this.currentLanguage].NO_ANSWER,
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: this.wordings[this.currentLanguage].YES_ANSWER,
                id: 'confirm-button',
                handler: () => {
                  console.log('Confirm Okay')
                  this.logOut()
                },
              },
            ],
          });
      return alert.present();
    },

    async logOut() {
      await store.commit("auth/SET_USER", null);
      localStorage.setItem('x-api-key', '');

      localStorage.setItem('user', '')
      window.location.reload();
      this.$router.push('/app/dashboard');
    },

    bannerClick() {
      //router.push({name: 'Dashboard'});
      this.$router.push('/app/dashboard');
    },
    async presentNotAllowedAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Not allowed',
            message: 'You do not have permission to see the content',
            buttons: [
              {
                text: 'Ok',
                id: 'confirm-button',
                handler: () => {
                  console.log('Confirm Okay')
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    }


  },

  async created() {

    this.isDesktop = isPlatform('desktop');
    this.isIos = isPlatform('ios');
    if (localStorage.getItem('x-api-key') != '') {

      let userRequest = await store.dispatch("auth/GET_USERDATA");

      if (userRequest)
        await store.commit("auth/SET_USER", userRequest.data);

      let token = await store.dispatch("auth/GENERATE_JWT");

      await store.commit("auth/SET_TOKEN", token);

      this.appointmentsRole = await store.dispatch("auth/GET_APPOINTMENT_ROLE");
    } else {
      // this.login();
    }
    //TODO:setting in config restricted and restricted marker
    if (this.user) {

      //await this.getUnreadMessagesTotalCount();
      await this.connectPersonalDB();
    }
    if (!isPlatform('mobile') || !config.is_app) {
       if (!this.user) {
        //this.login();
      } else if (this.user && this.user.user_no_virt_access) {
         //this.presentNotAllowedAlert();
      }

    }


    this.setShowSplash(true)
    //  console.log(this.user)
    this.prepareLinks();
    //this.prepareLinksTop();
    await this.changeSettings();

  },

  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeUnmount() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },

  watch: {
    updateFinished: async function (newVal) {
      //   console.log('FINISH')
      if (newVal) {
        await this.prepareLinks();
        //await this.prepareLinksTop();

        await this.changeSettings()
        //shows splash after every update
        //this.setShowSplash(true)


        //TODO: comment in for login
        /*if (isPlatform('mobile')){
          if (!this.user) {
            alert('You need to login in order to access all data')
            this.login();
          } else if (this.user && !this.user.user_tn_marker) {
            this.presentNotAllowedAlert();
          }
        }*/
      }
    },
    '$route': {
      immediate: true,
      async handler(route) {

        if (route.name == 'Dashboard') {
          this.historyCount = 0;
        } else {
          this.historyCount += 1;
          console.log('history', this.historyCount)
        }
        if (route.name == 'Search with term') {
          this.hideSearchBar = true;
        } else {
          this.hideSearchBar = false;
        }
      }
    },
    onLine(v) {
      if (v) {
        this.showBackOnline = true;
        setTimeout(() => {
          this.showBackOnline = false;
        }, 1000);
      }
    }
  }

};
</script>
<style>
.lang-row {
  text-align: center !important;
  border-style: none;
  border-radius: 0px !important;
}

.lang-flag {
  vertical-align: center !important;
  margin: 1px !important;
}

.nonselected-lang .lang-flag {
  filter: grayscale(100%) brightness(0.7);
  opacity: 0.6;
  transition: all 0.3s ease;
}

.nonselected-lang:hover .lang-flag {
  filter: grayscale(50%) brightness(0.85);
  opacity: 0.8;
}

.selected-lang .lang-flag {
  filter: none;
  opacity: 1;
}


.menu-content-open {
  pointer-events: unset !important;
}

.menu-content.menu-content-open {
  z-index: 20;
}

.ion-menu-content-area {
  --padding-start: 0px;
  --padding-end: 0px;


}

</style>

<style lang="scss" scoped>

.msg-badge {
  padding: 2px;
  font-size: 12px;
  height: 15px;
  width: 15px;
}

$conf-color: #69A653;
.branding-wrapper {
  color: #fff !important;
  //background: url(../img/splash-bg.jpg) no-repeat center center fixed;
  background-color: $conf-color !important;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  --background: -moz-linear-gradient(180deg, $conf-color 0%, $conf-color 50%, rgba(109, 140, 162, 0.4) 100%); /* FF3.6-15 */
  --background: -webkit-linear-gradient(180deg, $conf-color 0%, $conf-color 50%, rgba(109, 140, 162, 0.4) 100%); /* Chrome10-25,Safari5.1-6 */
  --background: linear-gradient(180deg, $conf-color 0%, $conf-color 50%, rgba(109, 140, 162, 0.4) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#333F6A88', endColorstr='#336D8CA2', GradientType=1); /* IE6-9 fallback on horizontal gradient */


  .branding-intro {
    width: 100%;
    max-width: 600px;
    max-height: 30px;
  }

  #branding-intro-logo-image path {

  }

  #branding-intro-logo-text path {
    stroke: #fff;
    stroke-dasharray: 2200;
    stroke-dashoffset: 1000;
    animation: dash-text 2s ease-out forwards 1;
    transition: fill .2s ease-out;
  }

  .btn:focus,
  .btn:active:focus,
  .btn.active:focus,
  .btn.focus,
  .btn:active.focus,
  .btn.active.focus {
    outline: none !important;
    box-shadow: none;
  }


}

/* Ensure proper z-index for offcanvas and backdrop */
.offcanvas.show, .offcanvas.showing {
  z-index: 1045 !important;
}

.offcanvas-backdrop {
  z-index: 1040 !important;
}

/* Additional fix for when opened via swipe */
#offcanvasNavbar {
  z-index: 1045 !important;
}
</style>

<style lang="scss">
.consent-disclaimer {
  .alert-wrapper {
    width: 95vw !important;
    max-width: 95vw;
    height: 95vh;

  }

  .alert-message.sc-ion-alert-md {
    max-height: 100% !important;
  }

  .alert-message.sc-ion-alert-ios {
    max-height: 100% !important;
  }


}

@media (min-width: 992px) {
  .navbar > .container-fluid {
    justify-content: unset !important;
  }
}

</style>
